export default __webpack_public_path__ + "48fc2546e250ba41dd42f1268b588fde.png";